import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  creatorOnly?: boolean;
  adminOnly?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, creatorOnly, adminOnly }) => {
  const { currentUser, effectiveRole, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!currentUser) {
    return null;
  }

  const redirectTo = effectiveRole === 'respondent' ? '/feedback/assigned' : '/dashboard';

  if (adminOnly && effectiveRole !== 'admin') {
    return <Navigate to={redirectTo} replace />;
  }

  if (creatorOnly && effectiveRole !== 'creator' && effectiveRole !== 'admin') {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;